define('lq/events/actions/extractMailAttachment',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function ExtractMailAttachment(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ExtractMailAttachment, EventAction);

    ExtractMailAttachment.typeName = 'ExtractMailAttachment';

    ExtractMailAttachment.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    ExtractMailAttachment.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "ExtractMailAttachment",
            commandId: this.eventData.command
        };
    };

    ExtractMailAttachment.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    return ExtractMailAttachment;
});
